export const CUSTOMER_DETAIL_REQUEST = `pages/app/CUSTOMER_DETAIL_REQUEST`;
export const SET_ACTIVE_DRAFT_SUGGESTION = `SET_ACTIVE_DRAFT_SUGGESTION`;
export const SET_DEPARTMENT_LIST = `SET_DEPARTMENT_LIST`;
export const SET_UPDATE_SUGGESTION_DETAILS = `SET_UPDATE_SUGGESTION_DETAILS`;
